<template>
  <div>
    <h1 class="title-text">
      Paste your introduction or testimonial video links here then click the green button below.
    </h1>
    <v-text-field v-model="videoLink" required class="video-placeholer-color"></v-text-field>
    <v-btn class="mr-4 main-btn success-green" @click="addVideoLink()"> Youtube or Vimeo </v-btn>
    <br />

    <br />

    <file-pond
      label-idle="Drag and Drop your files or Browse to add photos"
      allow-multiple="true"
      :maxFiles="maxTotalFiles"
      :maxFileSize="maxFileSizeLabel"
      credits="false"
      name="file"
      ref="input"
      itemInsertLocation="after"
      @removefile="onremovefile"
      :beforeRemoveFile="beforeRemove"
      :beforeAddFile="beforeAddFile"
      allowFileTypeValidation="true"
      :acceptedFileTypes="acceptedFileTypes"
      filePosterMaxHeight="100"
      imagePreviewHeight="100"
      :server="{ process, restore, load, fetch: null }"
      :files="files"
      @init="handleFilePondInit"
    />
    <p class="upload-hint">{{ uploadHintText }}</p>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import API from '../../api';
import axios from 'axios';
import config from '@/config';
import router from '@/router';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
// Import the plugin code
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import the plugin styles
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import { parseVideo } from '@/util/video';
import {
  getAcceptedFileTypes,
  getUploadHintText,
  getMaxTotalFiles,
  getMaxFileSizeLabel,
  MAX_FILES_PER_UPLOAD
} from '@/util/uploadFileTypes';

// Register the plugin
// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFilePoster);

/* eslint-disable no-debugger */

let imageFiles = {};

/* eslint-disable-next-line  */
export default {
  name: 'Library',
  props: {},

  components: {
    FilePond
  },

  data: () => ({
    files: [],
    videoLink: '',
    images: []
  }),
  //LOAD
  created: async function () {
    this.error = null;
    let res = await API.get('profile');
    if (!res) {
      return;
    }
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      this.error = null;

      this.images = res.data.images;
    }
  },
  mounted() {
    document.title = 'Edit Library';
  },
  computed: {
    acceptedFileTypes() {
      return getAcceptedFileTypes('library');
    },
    uploadHintText() {
      return getUploadHintText('library');
    },
    maxTotalFiles() {
      return getMaxTotalFiles('library');
    },
    maxFileSizeLabel() {
      return getMaxFileSizeLabel('library');
    }
  },
  methods: {
    process(fieldName, file, metadata, load, error, progress, abort) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      let cancelled = false;

      (async () => {
        try {
          // Step 1: ask the backend for a presigned S3 URL + uuid/key for this file
          let presignedRes = await API.post('file/presigned-url', {
            fileType: 'library',
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            needsThumbnail: false
          });

          if (presignedRes.errors && presignedRes.errors.length > 0) {
            error(presignedRes.errors[0].msg);
            return;
          }

          let { uuid, key, presignedUrl } = presignedRes.data;

          if (cancelled) return;

          // Step 2: upload the file directly to S3 using the presigned URL,
          // reporting progress back to FilePond and honoring cancellation.
          const s3Axios = axios.create();
          delete s3Axios.defaults.headers.common['Authorization'];

          await s3Axios.put(presignedUrl, file, {
            headers: {
              'Content-Type': file.type || 'application/octet-stream'
            },
            cancelToken: source.token,
            onUploadProgress: e => {
              progress(e.lengthComputable, e.loaded, e.total);
            }
          });

          if (cancelled) return;

          // Step 3: confirm the upload with the backend so a UserFile row gets created
          let confirmRes = await API.post('file/confirm-upload', {
            uuid,
            key,
            fileName: file.name,
            fileType: 'library'
          });

          if (confirmRes.errors && confirmRes.errors.length > 0) {
            error(confirmRes.errors[0].msg);
            return;
          }

          // passing the file id to FilePond
          load(confirmRes.data.uuid);
        } catch (thrown) {
          if (axios.isCancel(thrown)) {
            console.log('Request canceled', thrown.message);
          } else {
            error(thrown.message || 'Upload failed');
          }
        }
      })();

      // Setup abort interface
      return {
        abort: () => {
          cancelled = true;
          source.cancel('Operation canceled by the user.');
          abort();
        }
      };
    },
    async onremovefile(err, file) {
      if (err) return;
      if (!file || !file.serverId) return;

      let uuid = file.serverId;

      try {
        await API.post('file/delete', { uuid });
      } catch (deleteErr) {
        console.error('Failed to delete file', deleteErr);
      }

      this.images = this.images.filter(image => image.uuid !== uuid);
    },
    beforeRemove: file => true,
    // Caps how many files can be added in a single drop/selection action
    // (independent of the total gallery cap enforced by :maxFiles). FilePond
    // calls this once per file in a batch, synchronously, before yielding —
    // so a running counter reset on the next microtask correctly identifies
    // "files added together in one action" without needing a debounce timer.
    beforeAddFile(fileItem) {
      return new Promise(resolve => {
        this._batchAddCount = (this._batchAddCount || 0) + 1;
        const thisCallCount = this._batchAddCount;

        Promise.resolve().then(() => {
          if (this._batchAddCount === thisCallCount) {
            this._batchAddCount = 0;
          }
        });

        if (thisCallCount > MAX_FILES_PER_UPLOAD) {
          this.error = `You can only add up to ${MAX_FILES_PER_UPLOAD} files at a time.`;
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    load: (uniqueFileId, load, error, progress, abort, headers) => {
      let file = imageFiles[uniqueFileId];
      fetch(file.url)
        .then(res => {
          console.log(res);
          return res.blob();
        })
        .then(load);
    },
    fetch(url, load, error, progress, abort, headers) {
      error('not supported');
    },
    restore(uniqueFileId, load, error, progress, abort, headers) {
      error();
    },
    handleError(error, e) {
      switch (e.code) {
        case 'storage/canceled':
          break;
        default:
          error(e.message);
      }
    },
    handleFilePondInit: function () {
      //this.$refs.input.getFiles();
    },

    async addVideoLink() {
      let parseRes = parseVideo(this.videoLink);
      let id;
      let type;
      if (parseRes && parseRes.type) {
        id = parseRes.id;
        type = parseRes.type;
      } else {
        alert('Invalid video link');
        return;
      }
      let res = await API.post('file/uploadVideoLink', {
        id,
        type
      });
      if (res.data) {
        this.$refs.input.addFile(
          res.data.uuid,

          // set type to local to indicate an already uploaded file
          {
            index: this.$refs.input.files.length,
            type: 'local',

            // stub file information
            file: {
              name: 'video',
              type: 'video'
            },

            // pass poster property
            metadata: {
              poster: res.data.thumbnailUrl
            }
          }
        );
      }

      this.videoLink = '';
    }
  },
  watch: {
    images: {
      immediate: true,
      handler: function (images, oldVal) {
        let files = [];

        for (let index = 0; index < images.length; index++) {
          const image = images[index];
          imageFiles[image.uuid] = image;
          let file = {
            source: image.uuid,
            options: {
              type: 'local'
            }
          };
          if (image.thumbnailUrl) {
            file.options.metadata = {
              poster: image.thumbnailUrl
            };
            file.options.file = {
              name: 'video',
              type: 'video'
            };
          }
          files.push(file);
        }
        this.files = files;
      }
    }
  }
};
</script>

<style>
.avatar {
  width: 140px !important;
  height: 140px !important;
  top: -70px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.filepond--item {
  width: calc(50% - 0.5em);
}
.upload-hint {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
  margin-bottom: 0;
}
.video-placeholer-color input::placeholder {
  color: black !important;
  opacity: 1;
}

.video-label-color .v-label {
  color: black;
  opacity: 1;
}

.video-placeholer-color input,
.video-label-color input {
  color: black !important;
}
</style>
